import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, DialogContentText
} from '@mui/material';

const DomainDetailsDialog = ({ open, handleClose, sortedDomains }) => {
    return (
        <Dialog open={open} onClose={handleClose} sx={{ '& .MuiDialog-paper': { width: '65vh', height: '65vh' } }}>
            <DialogTitle>Domain Details</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 300, border: '1px solid #ddd' }}>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                    <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid #aaa' }}>domain_id</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid #aaa' }}>domain_name</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sortedDomains.map(([key, value]) => (
                                    <TableRow key={key} sx={{ '&:nth-of-type(even)': { backgroundColor: '#fafafa' } }}>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>{key}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>{value}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DomainDetailsDialog;
